import angular from 'angular'
import fullEleInvoice from './fullEleInvoice'
import openedFullEleInvoice from './openedFullEleInvoice'
import drawer from './drawer'
import redInkConfirmForm from './redInkConfirmForm'
import fullEleInvoiceIsAbnormal from './fullEleInvoiceIsAbnormal'
export default angular.module('outputManage.fullElectricInvoice', [fullEleInvoice, openedFullEleInvoice, drawer, redInkConfirmForm, fullEleInvoiceIsAbnormal]).config([
    '$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('outputManage.fullElectricInvoice', {
            url: '/ovat',
            template: '<div ui-view></div>',
            abstract: true,
            title: '全电发票',
        })
        // .state()
    },
]).name



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/index.js